import { combineReducers } from "redux";
import cart from "./modules/cart";
import entities from "shadow-client/redux/modules/Entities";

export default combineReducers({
  entities,
  cart
});



// WEBPACK FOOTER //
// ./src/app/redux/rootReducer.js